import { getConfig } from "@/config";
import { type Locale } from "@/domain";

import { ReviewsRatingsClient } from "./ReviewsRatings.client";

export interface ReviewsRatingsProps {
	sku: string;
	locale: Locale;
	/** Optional overrides for testing/Storybook */
	scriptUrl?: string;
	apiKey?: string;
	merchantGroupId?: string;
	merchantId?: string;
}

export function ReviewsRatings({
	sku,
	locale,
	...overrides
}: ReviewsRatingsProps): JSX.Element {
	let powerReviews: any;
	try {
		const config = getConfig();
		powerReviews = config?.powerReviews;
	} catch (e) {
		// Ignore config errors in browser/Storybook environment
	}

	const creds = powerReviews?.byLocale?.[locale];

	const scriptUrl = overrides.scriptUrl ?? powerReviews?.scriptUrl;
	const apiKey = overrides.apiKey ?? creds?.apiKey;
	const merchantGroupId = overrides.merchantGroupId ?? creds?.merchantGroupId;
	const merchantId = overrides.merchantId ?? creds?.merchantId;

	if (!scriptUrl || !apiKey || !merchantGroupId || !merchantId) {
		// In a real server environment, loadPowerReviewsConfig throws if missing.
		// In Storybook/Client, we just don't render.
		return <></>;
	}

	return (
		<ReviewsRatingsClient
			scriptUrl={scriptUrl}
			payload={{
				sku,
				locale,
				apiKey,
				merchantGroupId,
				merchantId
			}}
		/>
	);
}
